// Mirrors the legacy /app/auth/callback/route.ts:34-40 path validation. Used
// anywhere a `?next=` query param can drive a client-side navigation:
//   - /login (after sign-in)
//   - /auth/callback (after exchange)
//   - /reset-password (after password change)
//
// Rejects protocol-relative URLs (//evil.com/x) and backslash-prefixed
// variants (/\evil.com) that some browsers normalise into off-origin URLs.
// Only allows paths that start with a single `/` followed by safe characters.
export function isSafeNext(next: string | null | undefined): next is string {
  if (!next) return false;
  if (next.startsWith("//") || next.startsWith("/\\")) return false;
  return /^\/[A-Za-z0-9_/?&=%.-]/.test(next);
}
